import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as swalFunctions from '../../data/sweet-alerts';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {FilesService} from '../../services/files.service';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constants} from '../../constants/constants';

@Component({
  selector: 'app-modal-carga-documento',
  templateUrl: './modal-carga-documento.component.html',
  styleUrls: ['./modal-carga-documento.component.scss']
})
export class ModalCargaDocumentoComponent implements OnInit, AfterViewInit  {

  @ViewChild('modalDocumentoFirmado') modal: ElementRef;
  @Output() emitter: EventEmitter<EventosTablaInterface> = new EventEmitter<EventosTablaInterface>();
  @Input() evento: EventosTablaInterface;

  archivoFirmado: FormGroup;
  selectedFiles: FileList;
  swal = swalFunctions;
  procesando = false;
  errorExtension: number;
  extension: string;
  fileName = ' 0 archivos seleccionados.';
  message = '';

  constructor( public _files: FilesService,
               private modalService: NgbModal,
               private form: FormBuilder,
               private constants: Constants) { }

  ngOnInit(): void {
    this.iniciarForm();
  }

  ngAfterViewInit(): void {
    this.modalService.open(this.modal, {
      backdrop: 'static',
      keyboard: false
    });

    console.log(this.evento);
  }

  emit(accion: string): void {
    this.evento = {
      accion: accion
    }
    this.emitter.emit(this.evento);
  }

  iniciarForm() {
    this.archivoFirmado = this.form.group({
      adjunto: ['', Validators.required],
      id: [''],
      idtipter: ['']
    });
  }

  guardarArchivoFirmado(archivoFirmadoSave: any) {
    if (this.selectedFiles == null || archivoFirmadoSave.adjunto === '') {
      this.swal.TypeError('Sin Archivo', 'Es necesario carga un archivo en formato .pdf valido.');
    } else {
      this.uploadFiles(this.evento.objeto.idkey, 0, this.evento.objeto.tipo);
      this.procesando = true;
    }
  }

  uploadFiles(id: number, idtipo: number, tipo: string) {
    // Subimos los nuevos
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i], id, idtipo, tipo);
    }
  }

  upload(index, file, id: number, idtipo: number, tipo: string) {
    this._files.uploadFTP(file, id, idtipo, tipo).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.selectedFiles = null;
          this.fileName = ' 0 archivos seleccionados.';
        } else if (event instanceof HttpResponse) {
          this.selectedFiles = null;
          this.fileName = ' 0 archivos seleccionados.';
          this.swal.TypeSuccess('Archivo cargado', 'Verifique la información.');
          this.procesando = false;
        }
        this.iniciarForm();
      },
      err => {
        this.message = 'No se puede subir el archivo ' + file.name;
        this.swal.TypeError('Error Carga', this.message);
        this.procesando = false;
      });

  }



  selectFiles(event) {
    this.errorExtension = 0;

    for (const file of event.target.files) {
      this.extension = file.name.split('.').pop().toLowerCase();
      if (this.extension !== 'pdf' && this.extension !== 'docx' && this.extension !== 'doc') {
        this.errorExtension = 1;
        break;
      }
    }
    if (this.errorExtension == 1) {
      this.selectedFiles = null;
      this.fileName = ' 0 archivos seleccionados.';
      this.swal.TypeError('Error en extensión', 'Verifique la extensión de los archivos adjuntos, la extensión permitida es .pdf/.docx/.doc');
    } else {
      this.selectedFiles = event.target.files;
    }
  }

}
